import { render, staticRenderFns } from "./AssetRegistryHome.vue?vue&type=template&id=837b1872&scoped=true&"
import script from "./AssetRegistryHome.vue?vue&type=script&lang=js&"
export * from "./AssetRegistryHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837b1872",
  null
  
)

export default component.exports